// src/vuetify.js
import 'vuetify/styles' // Import Vuetify styles
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Optional: Import themes, icons, etc. if you want to customize
// import { aliases, mdi } from 'vuetify/iconsets/mdi'
// import { VBtn } from 'vuetify/components' // Example: Tree-shaking specific components

const vuetify = createVuetify({
  components, // Use all components
  directives, // Use all directives
  // Optional configuration:
  // theme: { ... },
  // icons: {
  //   defaultSet: 'mdi',
  //   aliases,
  //   sets: {
  //     mdi,
  //   }
  // },
  // You can also configure components globally here:
  // defaults: {
  //   VBtn: { variant: 'outlined' },
  // },
})

export default vuetify
